module.exports = __webpack_public_path__ + "static/media/world-map-off.2a46a3ff.png";